import React from 'react';
import { RouteTransitionLogo } from '../RouteTransitionLogo';

/**
 * Redesigned messages list shell. The logo shrinks and moves to a top
 * corner so the actual conversation list gets more real-estate. Title uses
 * a big editorial serif for personality.
 */
export const MessengerListShell = ({
  pageTestId,
  bellNode,
  bottomNav,
  logoSize = { width: 44, height: 40 },
  title = 'Messages',
  searchValue,
  onSearchChange,
  searchPlaceholder,
  searchTestId,
  searchIcon,
  cardHeader,
  children,
}) => (
  <div
    className="app-shell premium-page"
    data-testid={pageTestId}
    style={{
      height: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      backgroundColor: 'var(--app-bg)',
      paddingBottom: 118,
    }}
  >
    {/* Tight top row — small logo left, bell right, no huge vertical block */}
    <div
      style={{
        padding: '14px 20px 4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <RouteTransitionLogo
        width={logoSize.width}
        height={logoSize.height}
        dataTestId={`${pageTestId}-shared-logo`}
      />
      {bellNode}
    </div>

    {/* Editorial title + search block */}
    <div style={{ padding: '4px 20px 0', flexShrink: 0 }}>
      <h1
        data-testid={`${pageTestId}-title`}
        style={{
          fontFamily: "'Inria Serif', serif",
          fontSize: 30,
          fontWeight: 700,
          color: 'var(--text)',
          margin: 0,
          letterSpacing: '-0.01em',
        }}
      >
        {title}
      </h1>

      <div
        className="premium-search-shell"
        style={{
          marginTop: 12,
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          borderRadius: 9999,
          padding: '10px 14px',
          background: 'var(--surface)',
          border: '1px solid var(--card-border)',
          boxShadow: 'var(--premium-shadow-nested)',
        }}
      >
        {searchIcon}
        <input
          value={searchValue}
          onChange={onSearchChange}
          placeholder={searchPlaceholder}
          data-testid={searchTestId}
          style={{
            flex: 1,
            border: 'none',
            outline: 'none',
            background: 'transparent',
            fontFamily: "'Inria Serif', serif",
            fontSize: 15,
            color: 'var(--text)',
          }}
        />
      </div>
    </div>

    {/* Filter chip row above the list (optional) */}
    {cardHeader ? (
      <div style={{ padding: '12px 20px 4px', flexShrink: 0 }}>{cardHeader}</div>
    ) : null}

    {/* List area — full-width, no more nested card frame so rows get more room */}
    <div
      style={{
        flex: 1,
        minHeight: 0,
        padding: '6px 12px 0',
        overflowY: 'auto',
      }}
    >
      {children}
    </div>

    {bottomNav}
  </div>
);
